var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DashboardCardScaffold",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c("MarketplaceIcon", {
                    staticClass: "h-8 w-8 fill-current text-primary-500 mr-2",
                  }),
                  _c(
                    "RouterLink",
                    {
                      staticClass: "hover:text-primary-500",
                      attrs: {
                        to: {
                          name: _vm.routes.MARKETPLACE_CONTRACTORS,
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "font-semibold text-base" }, [
                        _vm._v("Marketplace"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "UiButton",
                {
                  attrs: { id: "browseMarketplace" },
                  on: { click: _vm.redirectToMarketplace },
                  scopedSlots: _vm._u([
                    {
                      key: "icon",
                      fn: function () {
                        return [
                          _c("PlusIcon", {
                            staticClass: "text-white fill-current w-2.5 h-2.5",
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("div", { staticClass: "flex flex-initial" }, [
                    _vm._v("Browse Marketplace"),
                  ]),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "CardItemScaffold",
        {
          staticClass: "mb-2",
          attrs: {
            itemTitle: "New",
            flexRow: "",
            itemNumber: _vm.marketplaceTotal,
          },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("SimplePersonIcon", {
                    staticClass: "fill-current text-primary-500 h-5 w-5",
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.marketplaceUsers.length
            ? _c(
                "div",
                { staticClass: "flex items-center" },
                _vm._l(_vm.marketplaceUsers, function (user, index) {
                  return _c("CircleWithInitials", {
                    key: index,
                    staticClass: "mr-1",
                    attrs: {
                      showTooltip: "",
                      primary: "",
                      title: user.name,
                      id: user.id,
                      avatar: user.avatar,
                      route: _vm.routes.CONTRACTOR_PUBLIC_PAGE,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }